<template>
  <div ref="root" v-loading='loading'>
    <el-card v-loading="loading">
      <el-descriptions
        title="订单详情"
        direction="vertical"
        :column="3"
        border
        :labelStyle="{border: '1px solid #000000'}"
        :contentStyle="{border: '1px solid #000000'}"
      >
        <!-- 基本信息 -->
        <el-descriptions-item label="基本信息">
          <!-- 店铺 -->
          <div class="big">
            <div>店铺:</div>
            <div>{{Data.site}}</div>
          </div>
          <!-- 订单id -->
          <div class="big">
            <div>订单id:</div>
            <div>{{Data.ID_}}</div>
          </div>
          <!-- 平台状态 -->
          <div class="big">
            <div>平台状态:</div>
            <div>{{Data.status}}</div>
          </div>
          <!-- 下单时间 -->
          <div class="big">
            <div>下单时间:</div>
            <div>{{Data.date_created_gmt}}</div>
          </div>
          <!-- 物流方式 -->
          <div class="big">
            <div>物流方式:</div>
            <div>{{Data.shiptype}}</div>
          </div>
          <!-- 客户备注 -->
          <div class="big">
            <div>客户备注:</div>
            <div>{{Data.customer_note}}</div>
          </div>
          <!-- 国际物流单号 -->
          <div class="big">
            <div>国际物流单号:</div>
            <div>{{Data.int_no}}</div>
          </div>
          
        </el-descriptions-item>
        <!-- 交易信息 -->
        <el-descriptions-item label="交易信息">
          <!-- 订单金额 -->
          <div class="big">
            <div>订单金额:</div>
            <div>{{Data.total}}</div>
          </div>
          <!-- 运费金额 -->
          <div class="big">
            <div>运费金额:</div>
            <div>{{Data.shipping_total}}</div>
          </div>
          <!-- 币种 -->
          <div class="big">
            <div>币种:</div>
            <div>{{Data.currency}}</div>
          </div>
          <!-- 交易号 -->
          <div class="big">
            <div>交易号:</div>
            <div>{{Data.transaction_id}}</div>
          </div>
          <!-- 优惠金额 -->
          <div class="big">
            <div>优惠金额:</div>
            <div>{{Data.discount_total}}</div>
          </div>
          <!-- 付款方式 -->
          <div class="big">
            <div>付款方式:</div>
            <div>{{Data.payment_method}}</div>
          </div>
        </el-descriptions-item>
        <!-- 配送信息 -->
        <el-descriptions-item label="配送信息">
          <!-- 收件人 -->
          <div class="big">
            <div>收件人:</div>
            <div>{{Data.name}}</div>
          </div>
          <!-- 邮箱 -->
          <div class="big">
            <div>邮箱:</div>
            <div>{{Data.email}}</div>
          </div>
          <!-- 省/州 -->
          <div class="big">
            <div>省/州:</div>
            <div>{{Data.state}}</div>
          </div>
          <!-- 邮编 -->
          <div class="big">
            <div>邮编:</div>
            <div>{{Data.postcode}}</div>
          </div>
          <!-- 地址 -->
          <div class="big">
            <div>地址:</div>
            <div>{{Data.address}}</div>
          </div>
          <!-- 电话 -->
          <div class="big">
            <div>电话:</div>
            <div>{{Data.phone}}</div>
          </div>
          <!-- 国家 -->
          <div class="big">
            <div>国家:</div>
            <div>{{Data.country}}</div>
          </div>
          <!-- 城市 -->
          <div class="big">
            <div>城市:</div>
            <div>{{Data.city}}</div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-card v-loading="loading" class="box">
      <p>订购商品</p>
        <el-table
          :row-style="{height:'100px'}"
          :cell-style="{padding:1,borderColor:'#000000'}"
          :header-cell-style="{borderColor:'#000000'}"
          :data="tableData"
          border
          style="width: 100%;border: 1px solid #000000">
          <!-- SKU -->
          <el-table-column prop="sku" label="SKU" width="180">
          </el-table-column>
          <!-- 图片 -->
          <el-table-column label="图片" width="120px">
            <template slot-scope="scope">
              <img v-if="scope.row.image" :src="scope.row.image.src" alt="暂无图片" width="100px" >
            </template>
          </el-table-column>
          <!-- 名称 -->
          <el-table-column prop="name" label="名称" width="1000px">
          </el-table-column>
          <!-- 型号 -->
          <el-table-column  label="型号" width="100" align="left">
            <span slot-scope="scope">
              <div v-for="item in scope.row.meta_data" :key="item.id">{{ item.display_key == "Talla" || item.display_key == "Size" || item.display_key == "Taille" || item.display_key == "サイズ" ? "尺码:" + item.display_value : "" }}</div>
            </span>
          </el-table-column>
          <!-- 定制信息 -->
          <el-table-column  label="定制信息" width="200" align="left">
            <span slot-scope="scope">
              <div ref="val" v-for="item in scope.row.meta_data" :key="item.id">{{ item.display_key.substring(0,15) == "Nombre y Número" || item.display_key.substring(0,15) == "Name and Number" || item.display_key.substring(0,19) == "選手ネーム／ナンバーを選択してください" || item.display_key.substring(0,13) == "Nom et numéro" ? "字号:" + item.display_value : (item.display_key.substring(0,6) == "Parche" || item.display_key.substring(0,7) == "Ecusson" || item.display_key.substring(0,7) == "écusson" || item.display_key.substring(0,2) == "腕章" || item.display_key.substring(0,5) == "Patch" ? "袖标:" + item.display_value : (item.display_key.substring(0,10) == "Accesorios" || item.display_key.substring(0,11) == "Accessories" || item.display_key.substring(0,11) == "Accessoires" || item.display_key.substring(0,6) == "アクセサリー" ? "配件:" + item.display_value : "" ) ) }}</div>
            </span>
          </el-table-column>
          <!-- 单价 -->
          <el-table-column prop="price" label="单价">
          </el-table-column>
          <!-- 数量 -->
          <el-table-column prop="quantity" label="数量">
          </el-table-column>
        </el-table>
    </el-card>
  </div>
</template>

<script>
import { getOD } from '../../api/api'
export default {
  data() {
    return {
      Data: [],//订单详情
      loading: true,
      tableData: [],//订购商品
    };
  },
  created() {
    var un = window.localStorage.getItem('un');
    if(un == '' || un == null || un == undefined){
      this.loading = true;
      return false;
    }
    var id_ = this.$route.query.id;
    getOD(id_).then(res => {
      // console.log(res);
      this.Data = res[0];
      this.tableData = JSON.parse(res[0].line_items);
      this.loading = false;
    })
  },
  updated(){
      var arr = this.$refs.val;
      for(var i of arr){
        if(i.innerHTML == "袖标:Serie A" || i.innerHTML == "袖标:セリエA"){
            i.innerHTML = "袖标:意甲标";
        }else if(i.innerHTML == "袖标:Premier League + No room for racism" || i.innerHTML == "袖标:プレミアリーグ" || i.innerHTML == "袖标:Premier League"){
            i.innerHTML = "袖标:英超标";
        }else if(i.innerHTML == "袖标:Premier League d'or + No room for racism" || i.innerHTML == "袖标:Champions + No room for racism" || i.innerHTML == "袖标:ゴールドプレミアリーグ" || i.innerHTML == "袖标:Gold Premier League"){
            i.innerHTML = "袖标:英超金标(曼城)";
        }else if(i.innerHTML == "袖标:La Liga" || i.innerHTML == "袖标:ラリーガ"){
            i.innerHTML = "袖标:西甲标";
        }else if(i.innerHTML == "袖标:Bundesliga" || i.innerHTML == "袖标:ブンデスリーガ"){
            i.innerHTML = "袖标:德甲标";
        }else if(i.innerHTML == "袖标:Ligue 1" || i.innerHTML == "袖标:リーグアン"){
            i.innerHTML = "袖标:法甲标";
        }else if(i.innerHTML == "袖标:Coupe Libertadores 2" || i.innerHTML == "袖标:Copa Libertadores 2" || i.innerHTML == "袖标:リベルタドーレスカップ" || i.innerHTML == "袖标:CONMEBOL 2"){
            i.innerHTML = "袖标:2次南美解放杯冠军";
        }else if(i.innerHTML == "袖标:Coupe Libertadores" || i.innerHTML == "袖标:Copa Libertadores" || i.innerHTML == "袖标:リベレーターカップ" || i.innerHTML == "袖标:Copa Libertadores Cup"){
            i.innerHTML = "袖标:南美解放者杯";
        }else if(i.innerHTML == "袖标:Recopa Sudamericana" || i.innerHTML == "袖标:南米カップウィナーズカップ"){
            i.innerHTML = "袖标:南美优胜者杯";
        }else if(i.innerHTML == "袖标:Liga Portugal" || i.innerHTML == "袖标:リーガポルトガル"){
            i.innerHTML = "袖标:葡萄牙联赛标";
        }else if(i.innerHTML == "袖标:Coupe du monde 2022" || i.innerHTML == "袖标:Copa Mundial" || i.innerHTML == "袖标:ワールド カップ" || i.innerHTML == "袖标:FIFA World Cup 2022"){
            i.innerHTML = "袖标:世界杯标";
        }else if(i.innerHTML == "袖标:Écusson des qualifications 2022" || i.innerHTML == "袖标:FIFA Living Football" || i.innerHTML == "袖标:ワールドカップ予選" || i.innerHTML == "袖标:FIFA World Cup Qualification 2022"){
            i.innerHTML = "袖标:世界杯预赛标"
        }else if(i.innerHTML == "袖标:UEFA Champions League" || i.innerHTML == "袖标:Champions Leauge" || i.innerHTML == "袖标:チャンピオンズリーグ"){
            i.innerHTML = "袖标:欧冠";
        }else if(i.innerHTML == "袖标:UCL 5" || i.innerHTML == "袖标:Champions Leauge 5" || i.innerHTML == "袖标:チャンピオンズリーグ 5" || i.innerHTML == "袖标:UEFA Champions League 5"){
            i.innerHTML = "袖标:欧冠5";
        }else if(i.innerHTML == "袖标:UCL 6" || i.innerHTML == "袖标:Champions Leauge 6" || i.innerHTML == "袖标:チャンピオンズリーグ 6" || i.innerHTML == "袖标:UEFA Champions League 6"){
            i.innerHTML = "袖标:欧冠6";
        }else if(i.innerHTML == "袖标:UCL 7" || i.innerHTML == "袖标:Champions Leauge 7" || i.innerHTML == "袖标:チャンピオンズリーグ 7" || i.innerHTML == "袖标:UEFA Champions League 7"){
            i.innerHTML = "袖标:欧冠7";
        }else if(i.innerHTML == "袖标:UCL 13" || i.innerHTML == "袖标:Champions Leauge 13" || i.innerHTML == "袖标:チャンピオンズリーグ 13" || i.innerHTML == "袖标:UEFA Champions League 13"){
            i.innerHTML = "袖标:欧冠13";
        }else if(i.innerHTML == "袖标:UCL 14" || i.innerHTML == "袖标:チャンピオンズリーグ 14" || i.innerHTML == "袖标:UEFA Champions League 14"){
            i.innerHTML = "袖标:欧冠14";
        }else if(i.innerHTML == "袖标:Fondation" || i.innerHTML == "袖标:Fundación" || i.innerHTML == "袖标:財団" || i.innerHTML == "袖标:UEFA Foundation"){
            i.innerHTML = "袖标:基金会";
        }else if(i.innerHTML == "袖标:Champions de la Serie A" || i.innerHTML == "袖标:Campeones de la Serie A" || i.innerHTML == "袖标:セリエAチャンピオン" || i.innerHTML == "袖标:Champions Serie  A"){
            i.innerHTML = "袖标:意甲冠军";
        }else if(i.innerHTML == "袖标:Coupe d'Italie" || i.innerHTML == "袖标:Cockade de Italia" || i.innerHTML == "袖标:イタリアカップ" || i.innerHTML == "袖标:Cockade of Italy"){
            i.innerHTML = "袖标:意大利杯标";
        }else if(i.innerHTML == "袖标:FINALE PARIS 2022" || i.innerHTML == "袖标:FINAL PARIS 2022" || i.innerHTML == "袖标:ファイナルパリ2022"){
            i.innerHTML = "袖标:巴黎决赛2022";
        }else if(i.innerHTML == "袖标:Champions League Winner" || i.innerHTML == "袖标:チャンピオンズリーグ優勝者" || i.innerHTML == "袖标:UCL Title"){
            i.innerHTML = "袖标:欧冠卫冕标";
        }else if(i.innerHTML == "袖标:Women's Super League" || i.innerHTML == "袖标:FA女子スーパーリーグ" || i.innerHTML == "袖标:Barclays Women's Super League"){
            i.innerHTML = "袖标:巴克莱女子超级联赛标";
        }else if(i.innerHTML == "袖标:Nexen Tire"){
            i.innerHTML = "袖标:耐克森轮胎";
        }else if(i.innerHTML == "袖标:Coupe du monde des clubs de la FIFA" || i.innerHTML == "袖标:Copa Mundial de Clubes de la FIFA" || i.innerHTML == "袖标:FIFAクラブワールドカップ" || i.innerHTML == "袖标:FIFA Club World Cup"){
            i.innerHTML = "袖标:世俱杯标";
        }else if(i.innerHTML == "袖标:Copa 2022 " || i.innerHTML == "袖标:ディフェン ディング チャンピオン2022"){
            i.innerHTML = "袖标:卫冕2022";
        }else if(i.innerHTML == "袖标:14th UEFA Champions League Winner" || i.innerHTML == "袖标:第14回UEFAチャンピオンズリーグ優勝"){
            i.innerHTML = "袖标:卫冕14";
        }else if(i.innerHTML == "袖标:UEFA Women's Champions League" || i.innerHTML == "袖标:Copa de la UEFA Femenina" || i.innerHTML == "袖标:UEFA女子チャンピオンズリーグ" || i.innerHTML == "袖标:UWCL"){
            i.innerHTML = "袖标:UEFA女子冠军标 1";
        }else if(i.innerHTML == "袖标:We play strong"){
            i.innerHTML = "袖标:UEFA女子冠军标 2";
        }else if(i.innerHTML == "袖标:Champions de la Bundesliga 2022/23" || i.innerHTML == "袖标:Campeones de la Bundesliga 2022/23" || i.innerHTML == "袖标:ブンデスリーガチャンピオン2022/23" || i.innerHTML == "袖标:Bundesliga Champion 2022/23"){
            i.innerHTML = "德甲冠军2022/23";
        }else if(i.innerHTML == "袖标:Champions de la Bundesliga 2021/22" || i.innerHTML == "袖标:Campeones de la Bundesliga 2021/22" || i.innerHTML == "袖标:ブンデスリーガチャンピオン2021/22" || i.innerHTML == "袖标:Bundesliga Champions 21/22"){
            i.innerHTML = "袖标:德甲冠军2021/22";
        }else if(i.innerHTML == "袖标:10th Champion" || i.innerHTML == "袖标:10 Campeones" || i.innerHTML == "袖标:10回チャンピオン" || i.innerHTML == "袖标:Serienmeister"){
            i.innerHTML = "袖标:拜仁10次冠军标";
        }else if(i.innerHTML == "袖标:10th Champion 2022" || i.innerHTML == "袖标:Champion 2022" || i.innerHTML == "袖标:第10回チャンピオン2022" || i.innerHTML == "袖标:10th Champion 2022"){
            i.innerHTML = "袖标:巴黎10连冠标";
        }else if(i.innerHTML == "袖标:Champions de la Liga Portugal" || i.innerHTML == "袖标:Campeones de la Liga Portugal" || i.innerHTML == "袖标:ポルトガルリーグチャンピオン" || i.innerHTML == "袖标:Champions Liga Portugal"){
            i.innerHTML = "袖标:葡萄牙甲级联赛冠军";
        }else if(i.innerHTML == "袖标:Insigne d'Honneur 7 Coupes" || i.innerHTML == "袖标:7 Champions Leauge" || i.innerHTML == "袖标:7チャンピオンズリーグ" || i.innerHTML == "袖标:BOH7"){
            i.innerHTML = "袖标:7次杯标";
        }else if(i.innerHTML == "袖标:digitalbits"){
            i.innerHTML = "袖标:digitalbits赞助补丁";
        }else if(i.innerHTML == "袖标:Bitget"){
            i.innerHTML = "袖标:Bitget赞助补丁";
        }else if(i.innerHTML == "袖标:BitMEX"){
            i.innerHTML = "袖标:BitMEX赞助补丁";
        }else if(i.innerHTML == "袖标:Scope Markets"){
            i.innerHTML = "袖标:Scope Markets 赞助补丁";
        }else if(i.innerHTML == "袖标:WhaleFin"){
            i.innerHTML = "袖标:WhaleFin 赞助商标";
        }else if(i.innerHTML == "袖标:Expedia"){
            i.innerHTML = "袖标:Expedia 赞助商标";
        }else if(i.innerHTML == "袖标:KOHLER"){
            i.innerHTML = "袖标:KOHLER赞助补丁";
        }else if(i.innerHTML == "袖标:DXC Technology" || i.innerHTML == "袖标:DXC"){
            i.innerHTML = "袖标:DXC Technology赞助商标";
        }else if(i.innerHTML == "袖标:BEKO" || i.innerHTML == "袖标:Beko"){
            i.innerHTML = "袖标:Beko 赞助补丁";
        }else if(i.innerHTML == "袖标:HARFID"){
            i.innerHTML = "袖标:HARFID";
        }else if(i.innerHTML == "袖标:Opel"){
            i.innerHTML = "袖标:Opel赞助补丁";
        }else if(i.innerHTML == "袖标:Qatar Airways"){
            i.innerHTML = "袖标:卡塔尔航空赞助商标";
        }else if(i.innerHTML == "袖标:ooredoo"){
            i.innerHTML = "袖标:ooredoo";
        }else if(i.innerHTML == "袖标:QNB"){
            i.innerHTML = "袖标:QNB";
        }else if(i.innerHTML == "袖标:GOAT"){
            i.innerHTML = "袖标:GOAT";
        }else if(i.innerHTML == "袖标:Kalise"){
            i.innerHTML = "袖标:Kalise赞助商标";
        }else if(i.innerHTML == "Cygames"){
            i.innerHTML = "袖标:Cygames赞助商标";
        }else if(i.innerHTML == "袖标:Cinch"){
            i.innerHTML = "袖标:Cinch赞助商标";
        }else if(i.innerHTML == "袖标:Ammerlander"){
            i.innerHTML = "袖标:阿莫兰赞助商标";
        }else if(i.innerHTML == "袖标:HYUNDAI" || i.innerHTML == "袖标:Hyundai"){
            i.innerHTML = "袖标:现代汽车赞助商标";
        }else if(i.innerHTML == "袖标:VISIT RWANDA" || i.innerHTML == "袖标:Visit Rwanda"){
            i.innerHTML = "袖标:VISIT RWANDA";
        }else if(i.innerHTML == "袖标:Würth" || i.innerHTML == "袖标:Wurth"){
            i.innerHTML = "袖标:伍尔特赞助商标";
        }else if(i.innerHTML == '配件:Shorts' || i.innerHTML == '配件:Pantalones Cortos' || i.innerHTML == '配件:Des pantalons courts' || i.innerHTML == '配件:短パン'){
          i.innerHTML = '配件:球裤';
        }else if(i.innerHTML == '配件:Socks' || i.innerHTML == '配件:Medias' || i.innerHTML == '配件:Chaussettes de foot' || i.innerHTML == '配件:ソックス' || i.innerHTML == '配件:Chaussettes'){
          i.innerHTML = '配件:袜子';
        }
      }
  }
};
</script>

<style lang="scss" scoped>
p{
  font-weight: bolder;
  margin-bottom: 10px;
}
.big{
  div:nth-child(1){
    width: 100px;
  }
  div{
    display: inline-block;
  }
}
.box{
  .el-table{
    display: inline-block;
    vertical-align: top;
  }
}
</style>
